interface WhyChooseOfx {
  title: string;
  text: string;
}

export const whyChooseOfx: WhyChooseOfx[] = [
  {
    title: 'Great rates',
    text: 'Keep more of your money as it travels around the world',
  },
  {
    title: '50+ currencies',
    text: 'Make transfers to over 170 countries',
  },
  {
    title: 'Easy to use',
    text: 'Check rates, make payments or track transfers online or via our app.',
  },
  {
    title: 'Peace of mind',
    text: 'OFX is ASX-listed and monitored by over 50 regulators globally',
  },
  {
    title: 'We know FX',
    text: 'Markets can move, we can help you plan for ups or downs',
  },
  {
    title: '24/7 support',
    text: 'Talk to a real person at any time, day or night',
  },
];
